import React from "react"
import { ThemeProvider } from "@mui/material"
import "dayjs/locale/ru"

import { Provider } from "react-redux"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import updateLocale from "dayjs/plugin/updateLocale"
import timezone from "dayjs/plugin/timezone"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { theme } from "./theme/theme"
import { store } from "./store/store"
import Router from "./router"
import AxiosInterceptor from "./api/axios"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(updateLocale)
dayjs.updateLocale("ru", {})
dayjs.locale("ru")

const queryClient = new QueryClient()

declare global {
    interface Window { extended: any; }
}
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <AxiosInterceptor>
            <Router />
          </AxiosInterceptor>
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  )
}

export default App
